import { render, staticRenderFns } from "./ModelBaseVulkan.vue?vue&type=template&id=cc443b60&scoped=true"
import script from "./ModelBaseVulkan.vue?vue&type=script&lang=js"
export * from "./ModelBaseVulkan.vue?vue&type=script&lang=js"
import style0 from "./ModelBaseVulkan.vue?vue&type=style&index=0&id=cc443b60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc443b60",
  null
  
)

export default component.exports